import React from 'react';

import PropTypes from 'prop-types';
import { Divider } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { Th } from '../../ratePlans/components/css';
import VehicleInfoListRow from './vehicleInfoListRow';

const VehicleInfoList = ({ vehicleInfo, setVehicleInfo }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: {
      vehicleVIN,
      vehicleMake,
      vehicleModel,
      vehicleYear,
      vehicleQuantity
    }
  } = localizedStrings;

  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      <table style={{ border: '1px solid #e3e3e3' }}>
        <thead style={{ background: '#4b286d' }}>
          <Th>{vehicleVIN}</Th>
          <Th>{vehicleMake}</Th>
          <Th>{vehicleModel}</Th>
          <Th>{vehicleYear}</Th>
          <Th>{vehicleQuantity}</Th>
          <Th>Remove</Th>
        </thead>
        <tbody>
          {vehicleInfo.map((row, index) => (
            <VehicleInfoListRow
              key={`vehicleInfoListItem-${index + 1}`}
              rowIndex={index}
              row={row}
              vehicleInfo={vehicleInfo}
              setVehicleInfo={setVehicleInfo}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};

VehicleInfoList.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default VehicleInfoList;
